import React, { Component } from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { genRandomString } from '../utils/helpers';

function calculateBackgroundColor(props) {
  if (props.disabled) {
    return `#aaaaaa`;
  }
  if (props.kind === 'danger') {
    return `${props.theme.colors.danger}`;
  }
  return `${props.theme.colors.primary}`;
}

function calculateBorder(props) {
  // if (props.kind === 'text') {
  //   return 'none';
  // }
  // if (props.kind === 'success') {
  //   return 'none';
  // }
  return 'none';
}

function calculateColor(props) {
  // if (props.kind === 'success') {
  //   return '#ffffff';
  // }
  return '#fff';
}

function calculateCursor(props) {
  if (props.disabled) {
    return 'not-allowed';
  }
  return 'pointer';
}

function calculateTextDecoration(props) {
  if (props.kind === 'text') {
    return 'underline';
  }
  return 'none';
}

function calculateFontSize(props) {
  if (props.size === 'small') {
    return '14px;';
  }
  return '16px;';
}

function calculateFontWeight(props) {
  // if (props.size === 'large') {
  //   return 'bold;';
  // }
  return 'bold;';
}

function calculatePadding(props) {
  if (props.size === 'small') {
    // return '12px;';
    return '10px;';
  }
  // return '14px';
  return '12px';
}

function calculateHoverBackgroundColor(props) {
  if (props.disabled) {
    return `#aaaaaa`;
  }
  if (props.kind === 'danger') {
    return `${props.theme.colors.danger}`;
  }
  return `${props.theme.colors.hoverButtonBackground}`;
}

function calculateHoverScale(props) {
  if (props.disabled) {
    return 'scale(1.0)';
  }
  return 'scale(0.98)';
}

const StyledButton = styled.button`
  background-color: ${props => calculateBackgroundColor(props)};
  /* background-size: 200% auto; */
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
  /* box-shadow: 0 0 20px #eee; */
  border: ${props => calculateBorder(props)};
  border-radius: 5px;
  cursor: ${props => calculateCursor(props)};
  color: ${props => calculateColor(props)};
  padding: ${props => calculatePadding(props)};
  letter-spacing: 0.1rem;
  text-decoration: ${props => calculateTextDecoration(props)};
  transition: 0.2s;
  font-size: ${props => calculateFontSize(props)};
  font-weight: ${props => calculateFontWeight(props)};
  width: ${props => (props.fullWidth ? '100%' : 'unset')};
  /* font-family: ${props => props.theme.fonts.main}; */
  /* background-image: linear-gradient(180deg, #8aca40 0%, #00822e 100%); */
  /* background-size: 200% auto; */
  /* margin: 5px; */
  /* margin-left: ${props => (props.pullRight ? 'auto' : '5px')}; */
  /* text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3); */
  /* min-width: 70px; */

  &:hover {
    background-color: ${props => calculateHoverBackgroundColor(props)};
    transform: ${props => calculateHoverScale(props)};
  }
`;

class Button extends Component {
  render() {
    const { children } = this.props;
    const randomTTId = genRandomString(15);

    if (this.props.tooltip) {
      return (
        <>
          <StyledButton {...this.props}>
            <span data-tip data-for={randomTTId}>
              {children}
            </span>
          </StyledButton>
          <ReactTooltip id={randomTTId}>{this.props.tooltip}</ReactTooltip>
        </>
      );
    }

    return (
      <StyledButton {...this.props}>
        <span>{children}</span>
      </StyledButton>
    );
  }
}

export default Button;
